(() => {
  const key = Symbol.for('dirt.paper.service');
  if (window[key]) {
    window[key](document);
    return;
  }
  const mounted = new WeakSet();
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  function faq(root) {
    const input = root.querySelector('#service-faq-query');
    const status = root.querySelector('#service-faq-status');
    const topics = root.querySelector('.service-faq-topics');
    const groups = root.querySelector('.service-faq-groups');
    const section = root.closest('[data-dirt-paper-content]');
    const resetTemplate = section.querySelector('[data-faq-reset]');
    const emptyTemplate = section.querySelector('[data-faq-empty]');
    const records = [...groups.children].map(group => ({
      group,
      topic: [...topics.children].find(link => link.getAttribute('href') === `#${group.id}`),
      list: group.querySelector('.service-faq-questions'),
      questions: [...group.querySelectorAll('.service-faq-question')].map(node => ({ node, text: normalize(node.dataset.faqSearch) })),
    }));
    let searchMode = false;
    let shown = new Set(records.flatMap(record => record.questions.map(question => question.node)));
    let resetButton;
    let empty;

    function reset() {
      input.value = '';
      update();
      input.focus();
    }
    function update() {
      const terms = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      const searching = terms.length > 0;
      const nextShown = new Set();
      let count = 0;
      for (const record of records) {
        const matches = record.questions.filter(question => terms.every(term => question.text.includes(term)));
        record.list.replaceChildren(...matches.map(question => {
          if (searching !== searchMode || !shown.has(question.node)) question.node.open = searching;
          nextShown.add(question.node);
          return question.node;
        }));
        if (matches.length) {
          record.topic.querySelector('span').replaceChildren(String(matches.length), Object.assign(document.createElement('span'), {
            className: 'service-faq-sr-only', textContent: ` ${matches.length === 1 ? 'vraag' : 'vragen'}`,
          }));
          topics.append(record.topic);
          groups.append(record.group);
        } else {
          record.topic.remove();
          record.group.remove();
        }
        count += matches.length;
      }
      if (count) {
        empty?.remove();
        root.append(topics, groups);
      } else {
        topics.remove();
        groups.remove();
        if (!empty) {
          empty = emptyTemplate.content.firstElementChild.cloneNode(true);
          empty.querySelector('[data-faq-reset-all]').addEventListener('click', reset);
        }
        root.append(empty);
      }
      if (input.value) {
        if (!resetButton) {
          resetButton = resetTemplate.content.firstElementChild.cloneNode(true);
          resetButton.addEventListener('click', reset);
        }
        input.parentElement.append(resetButton);
      } else resetButton?.remove();
      status.textContent = searching ? `${count} ${count === 1 ? 'vraag gevonden' : 'vragen gevonden'}` : 'Zoek op een woord uit de vraag of het antwoord.';
      searchMode = searching;
      shown = nextShown;
    }
    input.addEventListener('input', update);
    if (input.value) update();
  }

  function mount(scope) {
    const roots = [...scope.querySelectorAll('[data-dirt-faq]')];
    if (scope.matches?.('[data-dirt-faq]')) roots.unshift(scope);
    for (const root of roots) {
      if (mounted.has(root)) continue;
      mounted.add(root);
      faq(root);
    }
    for (const nav of scope.querySelectorAll('.service-navigation')) {
      const active = nav.querySelector('[aria-current="page"]');
      if (active && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, active.offsetLeft - nav.offsetLeft - 12);
    }
  }
  window[key] = mount;
  document.addEventListener('shopify:section:load', event => mount(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
})();
